import React from 'react';

import { TGroupUser } from '@/console/features/card-layout/components/recent-groups-card/components/group-user/group-user.types';
import { ListItemDescription } from '@/shared/components/ui/list-item-description/list-item-description';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';
import { useDateUtils } from '@/shared/hooks/use-date-utils/use-date-utils';

export const GroupUser: React.FC<TGroupUser> = ({
  creationUser,
  updateUser,
  creationTimestamp,
  updateTimestamp,
}) => {
  const { formatLocalTime } = useDateUtils();

  const getUserInformation = () => {
    if (updateUser && updateTimestamp) {
      const { firstName, lastName } = updateUser;
      return { firstName, lastName, timestamp: updateTimestamp };
    }
    const { firstName, lastName } = creationUser!;

    return { firstName, lastName, timestamp: creationTimestamp };
  };

  const { firstName, lastName, timestamp } = getUserInformation();

  return (
    <ListItemDescription
      text1={formatLocalTime(timestamp)}
      text2={
        <TruncatedText
          variant="p10"
          maxLength={12}
          text={`${firstName} ${lastName}`}
        />
      }
    />
  );
};
